import React from 'react'
import { useAppContext } from '@hooks/useAppContext'

import BrandLogo from 'assets/icons/BrandLogo'

import './SplashScreen.scss'

// SplashScreen component
const SplashScreen: React.FC = () => {
    // Destructure loading state and setLoading function from app context
    const {
        appState: { loading } , setLoading,
    } = useAppContext()

    const DelayedText = () => (
        <div className="delayed-text">
            <div className="logoBrand">
                <BrandLogo />
            </div>
            Un momento por favor.<br />Estamos validando los datos
            <span className="loading-dots" />
        </div>
    )

    return (
        <div className="splash-screen-section" data-testid="splash-screen-section">
            <DelayedText />
        </div>
    )
}

export default SplashScreen
